import {AGGIORNA, ROUTE_ASSISTANCES, ROUTE_SEARCH} from "@/utils/context/constants";
import {getLocalStorage, LS_SEARCH_PARAMS} from "@/utils/storage";
import RHSelect from "@/components/RHSelect";
import Iconify from "@/components/iconify";
import {palette} from "@/theme/palette";
export const formatCurrency = (num) => (Math.round(num * 100) / 100).toFixed(2);
export const getAvatarRandom = () => {
  const rand = Math.round(Math.random() * (25 - 1) + 1);
  return `/assets/images/avatars/avatar_${rand}.jpg`;
}

export const findElement = (data, key, value, type = 'single') => {
  if(data.length === 0 || isEmpty(data)) {
    return null;
  }
  const aData = data.filter((el) => el[key] === value);
  return type === 'single' ? (aData.length === 1 ? aData[0] : null) : aData;
};

// ISO 3166-1 alpha-2
// ⚠️ No support for IE 11
export const countryToFlag = (isoCode) => {
  return typeof String.fromCodePoint !== 'undefined'
    ? isoCode
        .toUpperCase()
        .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
    : isoCode;
};

export const goToRoute = (event, navigate) => {
  const { route } = event.target.dataset;
  navigate(route);
};

export const navigateToRoute = (navigate, route) => {
  navigate(route);
};

export const gotoAssistance = (id, toAction, navigate) => {
  const basePath = `${ROUTE_ASSISTANCES}/${id}`;
  toAction === AGGIORNA
    ? navigateToRoute(navigate, `${basePath}/edit`)
    : navigateToRoute(navigate, `${basePath}/show`);
};

export const gotoFullSearch = (action = 'full', term, navigate) => {
  const basePath = `${ROUTE_SEARCH}/${action}`;
  navigateToRoute(navigate, `${basePath}/${term}`);
};

export const isObject = (_var) => typeof _var === 'object' && !Array.isArray(_var) && _var !== null;

export const isArray = (_var) => Array.isArray(_var);

export const isString = (_var) => typeof _var === 'string' || _var instanceof String;

export const isUuid = (_var) =>
  isString(_var) &&
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(_var);

function emptyObject(obj) {
  return isObject(obj) && Object.keys(obj).length === 0;
}
function emptyString(str) {
  if (!isString(str)) {
    return false;
  }
  let r = false;
  if (!str || !str.trim()) {
    r = true;
  }
  return r;
}
function emptyArray(arr) {
  return Array.isArray(arr) && !arr.length;
}

export const isEmpty = (_var) => {
  return emptyString(_var) || emptyObject(_var) || emptyArray(_var) || !_var;
};

export const isObjectNotEmptyAndValid = (obj) =>  {
  if(null === obj) {
    return false;
  }
  // Controlla che l'oggetto abbia delle chiavi (non è vuoto)
  if (Object.keys(obj).length === 0) {
    return false;
  }

  // Verifica che ci sia almeno una proprietà valida
  return Object.values(obj).some(value => value !== null && value !== undefined && value !== '');
}

export const scrollTo = (selector = '.formview') => {
  const element = document.querySelector(selector);
  element?.scrollIntoView({ behavior: "smooth", inline: "nearest" });
}

export const getColorFromState = function(state) {
  switch(state){
    case 'uncontrol':
      return 'dark';
      break;
    case 'working':
      return 'warning';
      break;
    case 'review':
    case 'closed':
      return 'success';
    default:
      return 'secondary';
      break;
  }
};

export const getNumberFromState = function(state) {
  switch(state){
    case 'uncontrol':
      return 0;
      break;
    case 'working':
      return 1;
      break;
    case 'review':
    case 'closed':
      return 2;
    default:
      return 0;
      break;
  }
};

export const manageMaterialsSelect = (materials) => {
  if(materials.length < 1) {
    return 'No Materiali';
  }
  const options = materials.map((el) => {
    return {
      id: el.id,
      label: `${!!el.qta ? "["+el.qta+"]" : ''} ${el.name} - ${!!el.price ? `${el.price}€` : '-'}`
    }
  });

  return (
    <RHSelect
      options={options}
      defaultValue={options[0].id}
      label={'Materiali'}
      withLabel={false}
    />
  )
};

export const cleanAddress = function(address, stopwords = ['undefined', 'null'])
{
  // Creazione di un'espressione regolare dinamica per le stopwords
  const stopwordsRegex = new RegExp(
    stopwords.map(word => `(?:,?\\s*${word}\\s*-?\\s*|\\s*-?\\s*${word}\\s*,?)`).join('|'),
    'g'
  );

  // Rimuove tutte le stopwords e aggiusta il formato
  return address
    .replace(stopwordsRegex, ' ') // Rimuove tutte le combinazioni di stopwords
    .replace(/\s*,\s*,/g, ' , ') // Rimuove doppie virgole
    .replace(/\s*-\s*/g, ' - ') // Normalizza i trattini
    .replace(/,\s*$/, '') // Rimuove virgole finali
    .trim(); // Rimuove spazi superflui
}

export const getPinAddress = function(lat, lon){
  if(!lat || !lon) {
    return '';
  }
  return (
    <Iconify icon='mdi-light:map-marker'
             title='Open on Google Maps'
             onClick={() => window.open(`https://www.google.it/maps/place/${lat},${lon}`)}
             sx={{cursor: 'pointer', marginLeft: '5px'}} />
  );
}
/*************************** GESTIONE COLORI **************************************/
/**
 * Get hex color [text/background] from given text
 * @param text
 * @returns {[string,string]}
 */
export const generateColorsFromText = function(text) {
  // Funzione hash per creare un valore numerico dal testo
  function hashString(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  }

  // Converti hash in un colore esadecimale
  function intToHexColor(intValue) {
    const hex = ((intValue >> 16) & 0xFFFFFF).toString(16).padStart(6, '0');
    return `#${hex}`;
  }

  // Calcola il contrasto tra due colori
  function getLuminance(hex) {
    const rgb = hex.match(/[A-Za-z0-9]{2}/g).map((v) => parseInt(v, 16) / 255);
    return rgb.map((c) => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)))
      .reduce((acc, c, i) => acc + c * [0.2126, 0.7152, 0.0722][i], 0);
  }

  function getContrastRatio(color1, color2) {
    const lum1 = getLuminance(color1);
    const lum2 = getLuminance(color2);
    return (Math.max(lum1, lum2) + 0.05) / (Math.min(lum1, lum2) + 0.05);
  }

  // Genera i colori
  if(isEmpty(text)) {
    return ['#1d3a5b', '#bac050'];
  }
  const hash = hashString(text);
  const backgroundColor = intToHexColor(hash); // Colore di sfondo
  let textColor = '#FFFFFF'; // Default bianco

  // Calcola contrasto e assegna un colore di testo adeguato
  if (getContrastRatio(backgroundColor, textColor) < 4.5) {
    textColor = '#000000'; // Cambia in nero se il contrasto non è sufficiente
  }

  return [backgroundColor, textColor];
}

/**
 * Get best text color from given background color and text colors
 * @param backgroundHex
 * @param textColors
 * @returns {null}
 */
export const getBestTextColor = (backgroundHex, textColors) => {
  function hexToRgb(hex) {
    hex = hex.replace(/^#/, "");
    let bigint = parseInt(hex, 16);
    return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
  }

  function luminance([r, g, b]) {
    let a = [r, g, b].map(v => {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
  }

  function contrastRatio(l1, l2) {
    return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
  }

  let backgroundLuminance = luminance(hexToRgb(backgroundHex));

  let bestColor = null;
  let bestContrast = 0;

  Object.entries(textColors).forEach(([key, color]) => {
    let textLuminance = luminance(hexToRgb(color));
    let contrast = contrastRatio(backgroundLuminance, textLuminance);

    if (contrast > bestContrast) {
      bestContrast = contrast;
      bestColor = color;
    }
  });

  return bestColor;
}
const getBackgroundColor = (color = 'info', darkMode = false) => {
  let { neutral, common } = palette();

  let bgColor = darkMode ? neutral.main : palette()[color].dark || common.white;

  return bgColor;
};

export const getColor = (color = 'info') => {
  let { text } = palette();
  const bgColor = getBackgroundColor(color);
  /*let colorValue = bgWhite || color === 'light' ? text.primary : white.main;

  if (darkMode) {
    colorValue = color === 'light' ? 'inherit' : white.main;
  }*/

  let txtColor = getBestTextColor(bgColor, text);
  return {
    back: bgColor,
    txt: txtColor
  };
};

export const returnArrayWithRandomColors = (count) => {
  return Array.from({ length: count }, () => {
    const hex = Math.floor(Math.random() * 0xFFFFFF).toString(16);
    return `#${hex.padStart(6, '0')}`;
  });
};

export const showSnackbar = (enqSnackbar,msg, type, autoHide = 5000) => {
  enqSnackbar(
    msg,
    {
      variant: type,
      anchorOrigin: { horizontal: 'center', vertical: 'top' },
      autoHideDuration: autoHide
    }
  );
};

export const getFilenameBasedOnSearch = (type = 'search') => {
  const searchLS = getLocalStorage(LS_SEARCH_PARAMS);
  const params = JSON.parse(searchLS) ?? {};
  //console.log('params: ', params);
  /*if(isObjectNotEmptyAndValid(params)) {
    const a = Object.values(params).filter((el) => !!el);
    //console.log('filename: ', a.join('_'));
    return type + '_' + a.join('_');
  }*/
  if(!!params.data || !!params.anno) {
    return `${type}-${!isEmpty(params.data) ? params.data : ""}-${!isEmpty(params.anno) ? params.anno : ""}`;
  }
  return type;
}

/*** TIMING AND DEBOUNCING ***/
export function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = null;
      func.apply(context, args);
    }, wait);
  };
}
